module.exports = __webpack_public_path__ + "static/media/screen_landscape.956a7013.png";